import { useConfigService } from '@thd-nucleus/experience-context';
import { SEARCH_BANNER_CONFIG_KEY } from '../data-model/constants';

/**
 * Reads the ai-assisted-search-banner Config Service switch.
 *
 * Returns the raw value; whether it is renderable is the variant registry's call. Keeping that
 * decision in one place means there is no second list of known variants to hold in step, and a
 * value with no layout — missing, unrecognized, or explicitly disabled — leaves the banner off.
 *
 * @returns {(string|undefined)} The configured variant, or undefined when the switch is absent.
 */
export const useSearchBannerVariant = () => useConfigService(SEARCH_BANNER_CONFIG_KEY);
